import React, { useState, useCallback } from 'react';
import useEmblaCarousel from 'embla-carousel-react';
import { ChevronLeft, ChevronRight, Building } from 'lucide-react';
import { useProjects } from '../hooks/useProjects';
import ProjectModal from './ProjectModal';

const ProjectCarousel = () => {
  const { all: allProjects, loading } = useProjects();

  const [emblaRef, emblaApi] = useEmblaCarousel({ 
    loop: true,
    align: 'start',
    slidesToScroll: 1
  });
  const [selectedProject, setSelectedProject] = useState(null);

  const scrollPrev = useCallback(() => {
    if (emblaApi) emblaApi.scrollPrev();
  }, [emblaApi]);

  const scrollNext = useCallback(() => {
    if (emblaApi) emblaApi.scrollNext();
  }, [emblaApi]);

  return (
    <>
      <div className="project-carousel">
        {loading && allProjects.length === 0 ? (
          <div style={{ padding: '60px 20px', textAlign: 'center', color: '#6b7280' }} data-testid="carousel-loading">
            Loading projects...
          </div>
        ) : (
          <>
            <div className="embla" ref={emblaRef}>
              <div className="embla__container">
                {allProjects.map(project => (
                  <div key={project.id} className="embla__slide">
                    <div
                      className="project-slide-card"
                      onClick={() => setSelectedProject(project)}
                    >
                      <div className="project-slide-image">
                        <img src={project.image} alt={project.title} loading="lazy" decoding="async" />
                        <div className="project-slide-overlay">
                          <span className="project-slide-category">{project.category}</span>
                        </div>
                      </div>
                      <div className="project-slide-content">
                        <h3 className="project-slide-title">{project.title}</h3>
                        <p className="project-slide-client">{project.details.client}</p>
                        <p className="project-slide-description">{project.description}</p>
                        <div className="project-slide-details">
                          <span className="project-detail-item">
                            <Building size={16} />
                            {project.details.floors}
                          </span>
                          <span className={`status-badge ${(project.details.status || '').toLowerCase()}`}>
                            {project.details.status}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <button className="embla__prev" onClick={scrollPrev} aria-label="Previous">
              <ChevronLeft size={32} />
            </button>
            <button className="embla__next" onClick={scrollNext} aria-label="Next">
              <ChevronRight size={32} />
            </button>
          </>
        )}
      </div>

      {selectedProject && (
        <ProjectModal
          project={selectedProject}
          onClose={() => setSelectedProject(null)}
        />
      )}
    </>
  );
};

export default ProjectCarousel;
